import Vue from "vue";
import Cookie from "js-cookie";
import Router from "vue-router";
import store from "./store/index.js";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        // {
        //   path: "*",
        //   redirect: "/user"
        // },
        {
            path: "/",
            redirect: "/user"
        },
        //=======================下单==========================
        {
            path: "/preorder",
            name: "PreOrder",
            component: () => import('@/views/PreOrder/PreOrder'),
            // component: () => import('@/views/PreOrder'),
            meta: {
                requireAuth: true,
                title: "收件人下单",
                hideBack: true,
                hideNav: false,
                keepAlive: true
            }
        },
        {
            path: "/batchSentItem",
            name: "BatchSentItem",
            component: () => import('@/views/batchSentItem/BatchSentItem'),
            meta: {
                requireAuth: true,
                title: "寄件人下单",
                hideBack: true,
                hideNav: false,
                keepAlive: true
            }
        },
        {
            path: "/batchSentItem/sender",
            name: "Sender",
            component: () => import('@/views/batchSentItem/components/Sender'),
            meta: {
                requireAuth: true,
                title: "寄件人列表",
                hideBack: false,
                hideNav: true,
                keepAlive: false
            }
        },
        {
            path: "/batchSentItem/recipients",
            name: "Recipients",
            component: () => import('@/views/batchSentItem/components/Recipients'),
            meta: {
                requireAuth: true,
                title: "收件人列表",
                hideBack: false,
                hideNav: true,
                keepAlive: false
            }
        },
        {
            path: "/batchSentItem/batchOrderSuccess",
            name: "BatchOrderSuccess",
            component: () => import('@/views/batchSentItem/BatchOrderSuccess'),
            meta: {
                requireAuth: true,
                title: "下单成功",
                hideBack: false,
                hideNav: false,
                keepAlive: false
            }
        },
        {
            path: "/order/myorder",
            name: "MyOrder",
            component: () => import('@/views/order/MyOrder'),
            meta: {
                requireAuth: true,
                title: "我的订单",
                hideBack: true,
                hideNav: false,
            }
        },
        {
            path: "/order/waybill",
            name: "MyWayBill",
            component: () => import('@/views/order/MyWayBill'),
            meta: {
                requireAuth: true,
                title: "我的运单",
                hideBack: true,
                hideNav: false,
            }
        },
        {
            path: "/order/waybilldetail",
            name: "WayBillDetail",
            component: () => import('@/views/order/MyWayBillDetail'),
            meta: {
                title: "电子面单",
                hideBack: false,
                hideNav: false,
            }
        },
        {
            path: "/order/push/waybilldetail",
            name: "PushWayBillDetail",
            component: () => import('@/views/order/MyWayBillDetail'),
            meta: {
                title: "运单详情",
                hideNav: true,
                hideBack: true,
                requireAuth: false
            }
        },
        {
            path: "/order/location",
            name: "OrderLocation",
            component: () => import('@/views/order/OrderLocation'),
            meta: {
                requireAuth: true,
                title: "我的订单"
            }
        },
        {
            path: "/order/detail",
            name: "OrderDetail",
            component: () => import('@/views/order/MyOrderDetail'),
            meta: {
                requireAuth: true,
                title: "订单详情",
                hideBack: false,
                hideNav: false,
            }
        },
        {
            path: "/order/push/detail",
            name: "PushOrderDetail",
            component: () => import('@/views/order/MyOrderDetail'),
            meta: {
                title: "订单详情",
                hideNav: true,
                hideBack: true,
                requireAuth: false
            }
        },
        {
            path: "/order/modify/:id",
            name: "ModifyOrder",
            component: () => import('./views/order/ModifyOrder'),
            meta: {
                requireAuth: true,
                title: "订单修改",
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/search/logistics/:id",
            name: "Logistics",
            component: () => import('./views/search/Logistics.vue'),
            meta: {
                title: "物流查询",
                hideBack: false,
                hideNav: false,
                requireAuth: false,
            }
        },
        {
            path: "/search/logistic/:id",
            name: "Logistics",
            component: () => import('./views/search/Logistics.vue'),
            meta: {
                title: "物流查询",
                hideBack: false,
                hideNav: false,
                requireAuth: false,
                hideHeader: true
            }
        },
        {
            path: "/search/logistics",
            name: "LogisticsNormal",
            component: () => import('./views/search/Logistics.vue'),
            meta: {
                title: "物流查询",
                hideBack: false,
                hideNav: false,
                requireAuth: false
            }
        },
        {
            path: "/search/goodslogistics",
            name: "GoodsLogistics",
            component: () => import("./views/search/GoodsLogistics"),
            meta: {
                title: "货物查询",
                hideBack: true,
                hideNav: true,
                requireAuth: false
            }
        },
        {
            path: "/search/dot",
            name: "Dot",
            component: () => import("./views/search/Dot.vue"),
            meta: {
                title: "网点查询",
                hideBack: false,
                hideNav: false,
                requireAuth: false
            }
        },
        {
            path: "/search/branch",
            name: "Branch",
            component: () => import("./views/search/branch.vue"),
            meta: {
                title: "网点查询",
                keepAlive: true,
                hideBack: true,
                hideNav: false,
                requireAuth: false
            }
        },
        {
            path: "/search/line",
            name: "LineSearch",
            component: () => import("./views/search/Line.vue"),
            meta: {
                title: "专线查询",
                keepAlive: true,
                hideBack: false,
                hideNav: false,
                requireAuth: false
            }
        },
        {
            path: "/search/company",
            name: "CompanySearch",
            component: () => import("./views/search/CompnaySearch.vue"),
            meta: {
                title: "物流公司查询",
                hideBack: true,
                hideNav: false,
                keepAlive: true,
                requireAuth: false
            }
        },
        {
            path: "/search/companyprofile/:id",
            name: "CompanyProfile",
            component: () => import("./views/search/CompanyProfile.vue"),
            meta: {
                title: "公司简介",
                hideBack: false,
                hideNav: false,
                requireAuth: false
            }
        },
        // {
        //   path: "/addresslist/:type",
        //   name: "AdressList",
        //   component: () => import("./views/address/AddressList.vue"),
        //   meta: {
        //     requireAuth: true,
        //     title: "地址列表",
        //     hideBack: false,
        //     hideNav: true,
        //   }
        // },
        // {
        //   path: "/addresslist",
        //   name: "AllAddressList",
        //   component: () => import("./views/address/AllAddressList.vue"),
        //   meta: {
        //     requireAuth: true,
        //     title: "地址列表",
        //     hideBack: true,
        //     hideNav: true,
        //     keepAlive: true
        //   }
        // },
        // {
        //   path: "/order/addresslist/:type/:id",
        //   name: "OrderAddressList",
        //   component: () => import("./views/address/AddressList.vue"),
        //   meta: {
        //     requireAuth: true,
        //     title: "地址列表",
        //     hideBack: false,
        //     hideNav: true,
        //   }
        // },
        //==========================地址=======================================
        {
            path: '/sendAddress/:type',
            name: 'addSendAddress',
            component: () => import('@/views/address/SendAddress'),
            meta: {
                title: "新增寄件人",
                hideBack: false,
                hideNav: true,
            }
        },
        {
            path: '/sendAddress/:type/:id',
            name: 'editSendAddress',
            component: () => import('@/views/address/SendAddress'),
            meta: {
                title: "编辑寄件人",
                hideBack: false,
                hideNav: true,
            }
        },
        {
            path: '/acceptAddress/:type',
            name: 'addAcceptAddress',
            component: () => import('@/views/address/AcceptAddress'),
            meta: {
                title: "新增收件人",
                hideBack: false,
                hideNav: true,
            }
        },
        {
            path: '/acceptAddress/:type/:id',
            name: 'editAcceptAddress',
            component: () => import('@/views/address/AcceptAddress'),
            meta: {
                title: "编辑收件人",
                hideBack: false,
                hideNav: true,
            }
        },
        {
            path: '/sendAddressList',
            name: 'sendAddressList',
            component: () => import('@/views/address/SendAddressList'),
            meta: {
                title: '寄件人列表',
                hideBack: false,
                hideNav: true,
            }
        },
        {
            path: '/acceptAddressList',
            name: 'acceptAddressList',
            component: () => import('@/views/address/AcceptAddressList'),
            meta: {
                title: '收件人列表',
                hideBack: false,
                hideNav: true,
            }
        },
        //==================================支付======================================
        {
            path: "/defrayments",
            name: "Defrayments",
            component: () => import("./views/defrayment/Defrayments"),
            meta: {
                requireAuth: true,
                title: "支付运费",
                hideBack: false,
                hideNav: true
            }
        },
        {
            path: "/payment",
            name: "Payment",
            component: () => import("./views/defrayment/payment"),
            meta: {
                requireAuth: true,
                title: "支付运费",
                hideBack: true,
                hideNav: true
            }
        },
        {
            path: "/paymentSuccess",
            name: "PaymentSuccess",
            component: () => import("./views/defrayment/PaymentSuccess"),
            meta: {
                requireAuth: false,
                title: "支付成功",
                hideBack: true,
                hideNav: true
            }
        },
        //==================================个人中心==================================
        {
            path: "/user",
            name: "User",
            component: () => import("./views/user/User.vue"),
            meta: {
                requireAuth: true,
                title: "我的云服卡航",
                hideBack: true,
                hideNav: false,
            }
        },
        {
            path: "/user/setting",
            name: "Setting",
            component: () => import("./views/user/Setting.vue"),
            meta: {
                requireAuth: true,
                title: "设置",
                hideBack: false,
                hideNav: true,
            }
        },
        {
            path: "/user/login",
            name: "Login",
            component: () => import("./views/user/Login.vue"),
            meta: {
                title: "我的云服卡航",
                hideNav: true,
                hideBack: true
            }
        },
        {
            path: "/user/register",
            name: "Register",
            component: () => import("./views/user/Register.vue"),
            meta: {
                title: "我的云服卡航",
                hideBack: false,
                hideNav: true,
            }
        },
        {
            path: "/user/forgot",
            name: "ForgotPwd",
            component: () => import("./views/user/ForgotPwd"),
            meta: {
                title: "忘记密码",
                hideBack: true,
                hideNav: false,
            }
        },
        {
            path: "/user/addressbook",
            name: "AddressBook",
            component: () => import("./views/user/AddressBook.vue"),
            meta: {
                requireAuth: true,
                title: "通讯录",
                hideBack: false,
                hideNav: false,
            }
        },
        {
            path: "/user/suggestion",
            name: "Suggestion",
            component: () => import("./views/user/Suggestion.vue"),
            meta: {
                title: "投诉建议",
                hideBack: false,
                hideNav: false,
            }
        },
        {
            path: "/user/agreement",
            name: "Agreement",
            component: () => import("./views/user/Agreement.vue"),
            meta: {
                title: "《快递运单契约条款》",
                hideBack: false,
                hideNav: false,
            }
        },
        {
            path: "/push/info/:mobile",
            name: "PushInfo",
            component: () => import("./views/pushBinding/BindingInfo.vue"),
            meta: {
                title: "我的云服卡航",
                hideBack: true,
                hideNav: true
            }
        },
        {
            path: "/push/binding",
            name: "PushBinding",
            component: () => import("./views/pushBinding/PushBinding.vue"),
            meta: {
                title: "我的云服卡航",
                hideBack: true,
                hideNav: true
            }
        }, {
            path: "/cargoYards",
            name: "cargoYards",
            component: () => import("./views/order/components/CargoYards.vue"),
            meta: {
                title: "提货码",
                hideBack: true,
                hideNav: true
            }
        }, {
            path: "/cardRegister",
            name: "cardRegister",
            component: () => import("./views/cardRegister/cardRegister.vue"),
            meta: {
                title: "身份证信息登记",
                hideBack: true,
                hideNav: false
            }
        },
        {
            path: "/user/bind",
            name: "WxBind",
            component: () => import("./views/user/WxBind.vue"),
            meta: {
                requireAuth: true,
                title: "绑定",
                hideBack: true,
                hideNav: true,
            }
        },
        {
            path: "/organMap",
            name: "OrganMap",
            component: () => import("@/views/organMap/OrganMap.vue"),
            meta: {
                title: "柯莱顺发铁马总部",
                requireAuth: false,
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/myCoupon",
            name: "myCoupon",
            component: () => import("@/views/myCoupon/myCoupon.vue"),
            meta: {
                title: "我的优惠券",
                requireAuth: false,
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/couponDetails",
            name: "couponDetails",
            component: () => import("@/views/myCoupon/couponDetails.vue"),
            meta: {
                title: "优惠券详情",
                requireAuth: false,
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/user/inviteEnroll",
            name: "inviteEnroll",
            component: () => import("@/views/user/inviteEnroll.vue"),
            meta: {
                title: "邀请注册",
                requireAuth: false,
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/PcLogin",
            name: "PcLogin",
            component: () => import("@/views/user/PcLogin.vue"),
            meta: {
                title: "请使用PC账号登陆",
                requireAuth: false,
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/invite/order/details",
            name: "InviteOrderDetail",
            component: () => import("@/views/order/InviteOrderDetail.vue"),
            meta: {
                title: "订单详情",
                requireAuth: false,
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/invite/extend/details",
            name: "UserExtendCommission",
            component: () => import("@/views/invite/UserExtendCommission.vue"),
            meta: {
                title: "订单明细",
                requireAuth: true,
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
    ]
});
if (localStorage.getItem("yhb_token") || Cookie.get("yhb_token")) {
    store.commit("getToken");
}
// window.location.href=window.location.href.replace('/#','')
router.beforeEach((to, from, next) => {
    store.commit('setMeta', to.meta)
    if (!window.initUrl) {
        window.initUrl = location.href;
    }
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (to.hash.indexOf('#') != -1) {
            let path = to.hash.match(/\#(\S*)[\?]/)[0]
            let queryArr = to.hash.split('?')[1]
            queryArr = queryArr.split('=')
            let query = {}
            for (let i = 0; i < queryArr.length; i++) {
                if (i + 1) {
                    query[queryArr[i]] = queryArr[i + 1]
                }
            }
            path = path.replace('#', '').replace('?', '')
            next({
                path: path,
                query: query
            });
        } else if (store.state.token) {
            next();
        } else {
            next({
                path: "/user/login",
                query: {redirect: to.fullPath}
            });
        }
    } else {
        next();
    }
});

router.afterEach(() => {

    // setTitle(to, router.app)
    window.scrollTo(0, 0)
})

export default router;
